import { DataPropertyConverter /* , DataPropertyConverterArray*/ } from './data-property.converter';

export abstract class DataIdConverter<T extends { id: any }> extends DataPropertyConverter<T, 'id'> {
    constructor(contextKey: string) {
        super('id', contextKey);
    }
}

export class DataIdConverterFactory {
    static build<T extends { id: any }>(clazz: new () => T, contextKey: string) {
        class Converter extends DataIdConverter<T> {
            constructor() {
                super(contextKey);
            }
        }

        return Converter;
    }
}

export class DataIdArrayConverterFactory {
    static build<T extends { id: any }>(clazz: new () => T, contextKey: string) {
        class Converter {
            requiredContextKeys() {
                return { deserialize: [contextKey] };
            }
            deserialize(data: any[], context: any): T[] {
                if (data == null) {
                    return data as any;
                }
                const items: T[] = context && context[contextKey] ? context[contextKey] : [];
                return (data as any[]).map(id => {
                    const found = items.find(it => (it as any).id === id);
                    if (!found) {
                        throw new Error(`no item found with id in context '${contextKey}' for value '${id}'`);
                    }
                    return found;
                });
            }
            serialize(data: T[]): any[] {
                if (data == null) {
                    return data as any;
                }
                return (data as any[]).map(item => (item && typeof item === 'object' ? (item as any).id : item));
            }
        }
        return Converter;
    }
}
